import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-8 py-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, /*#__PURE__*/_toDisplayString("Gestão de Turmas"), -1)
const _hoisted_3 = { class: "w-full mx-8 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Classes = _resolveComponent("Classes")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    (_ctx.user?.role === 'TEACHER')
      ? (_openBlock(), _createBlock(_component_TabView, {
          key: 0,
          class: "!pb-0 custom-tabsForum",
          onTabChange: _ctx.changeTab,
          lazy: true
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, i) => {
              return (_openBlock(), _createBlock(_component_TabPanel, { key: i }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(tab.title), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(tab.component), { class: "mt-8" }))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["onTabChange"]))
      : (_openBlock(), _createBlock(_component_Classes, { key: 1 }))
  ]))
}